import httpCommon from "../http-common";

class UsersDataService{

    getTopThree(){
        return httpCommon.get(`/users?page=0&usersPerPage=3`);
    }

    getAll(page = 0){
        return httpCommon.get(`/users?page=${page}`);
    }

    get(username){
        return httpCommon.get(`/user/${username}`);
    }

    find(query, by = "username", page = 0){
        return httpCommon.get(`/users?${by}=${query}&page=${page}`);
    }

    createUser(data){
        return httpCommon.post(`/user/`, data);
    }
}

export default new UsersDataService();